// EmailJS Configuration
// Get your credentials from https://dashboard.emailjs.com/

export const emailjsConfig = {
  serviceId: 'service_ljwvorh',
  templateIds: {
    admin: 'template_2li8xid', // Admin notification template
    autoReply: 'template_n6182j5', // User auto-reply template
  },
  publicKey: '8q7_ufkm7s1C0cRW4',
};

// Email template parameters interface
export interface EmailParams extends Record<string, unknown> {
  from_name: string;
  reply_to: string;
  subject: string;
  message: string;
  submission_time?: string;
}
